var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-box"},[_c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }